// eslint-disable-next-line import/prefer-default-export
export const DIGITAL_CERTIFICATE_HELP_URL = 'https://support.modusign.co.kr/81468652671';
